<app-title-pages-component
  [pageData]="pageData"
  [showClientName]="true">
</app-title-pages-component>

@if (showForm) {
  <div class="container">
    <form [formGroup]="formOccupation" (ngSubmit)="handleSubmit()">
      <!-- Razón social -->
      <div class="form-row">
        <div class="input-container span-3">
          <input id="name" type="text" class="form-control" formControlName="name" required
                 [ngClass]="{ 'filled': formOccupation.get('name')?.value}"/>
          <label for="name">Nombre de la ocupación*</label>

          @if (submitted && name?.invalid && (!name?.untouched || name?.dirty || formOccupation)) {
            <div class="alert alert-danger">
              @if (name?.hasError('required') || name?.hasError('soloEspacios')) {
                <span>El nombre de la ocupación es requerido y no puede estar vacío.</span>
              }
            </div>
          }
        </div>


      </div>

      <div class="form-row-2">
        <button type="button" (click)="handleCancelAdd()">Cancelar</button>
        <button type="submit">Guardar</button>
      </div>
    </form>
  </div>
}

<app-table-with-inputs-component
  [columns]="columnDefinitions"
  [data]="occupations"
  (addSingle)="handleAddSingle()"
  (addBulk)="handleBulkUpload()"
  [editMode]="showBtn"
  [labelForSearch]="'Buscar ocupación'"
  [nameSeccion]="'ocupación'"
  (saveItem)="handleSaveEdit($event)"
  (eliminar)="showConfirmDeleteDialog($event)"
>
</app-table-with-inputs-component>

@if (showModal) {
  <app-confirm-delete-dialog
    [message]="message"
    (confirmar)="handleDelete()"
    (cancelar)="handleCancelDeleteDialog()"
  ></app-confirm-delete-dialog>
}

@if (showModalPasosCampaign) {
  <app-modal-pasos-campana (cerrar)="closeModalPasosCampaign()"></app-modal-pasos-campana>
}

@if (showBulkUploadModal) {
  <app-bulk-upload-modal
    [resourceLabel]="'Ocupaciones'"
    (downloadFormat)="onDescargarFormato($event)"
    (closeModal)="onBulkClose()"
    (confirm)="onBulkConfirm($event)">
  </app-bulk-upload-modal>

}


